export const GET_EMAILS = "GET_EMAILS";
export const GET_EMAIL_BY_ID = "GET_EMAIL_BY_ID";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const DELETE_EMAIL = "DELETE_EMAIL";
export const CREATE_EMAIL = "CREATE_EMAIL";
export const FORWARD_EMAIL = "FORWARD_EMAIL";
export const GET_EMAIL_DASHBOARD = "GET_EMAIL_DASHBOARD";
